import { ConfirmationLayout } from 'common/core/components/EmailConfirmationPage/ConfirmationLayout'

export const EmailConfirmationRoutes = [
  {
    path: 'confirm',
    Component: ConfirmationLayout,
    children: [
      {
        path: ':confirmation_hash',
        lazy: () => import('./emailConfirmation.page'),
      },
    ],
  },
] as const
